import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class UserService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  updateUser(user: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/${user.username}`;
    return this.http.put(REST_URL, user );
  }

  getUserListByWebId(webId): Observable<any> {
    const REST_URL = `${this.baseUrl()}`;
    return this.http.get(`${REST_URL}?webId=${webId}`);
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/users`;
  }
}
